import { HeaderLink } from './HeaderLink';
import { Collapse, styled } from '@mui/material';
import { HeaderLinkType } from '../Header';
import { LogoutButton } from './LogoutButton';
import { ContactProctorFreeButton } from './ContactProctorFreeButton';

const CollapseBox = styled(Collapse)(({ theme }) => ({
  [theme.breakpoints.down(924)]: {
    display: 'block',
  },
  [theme.breakpoints.up(924)]: {
    display: 'none',
  },
  borderBottom: `1px solid ${theme.palette.grey[300]}`,
  backgroundColor: theme.palette.grey[400],
}));

type PropsType = {
  links: HeaderLinkType[];
  isOpen: boolean;
  handleClose: () => void;
};

/**
 * Appears at sm breakpoint width (less than 724px)
 */
export const CollapsingMenu = ({ links, isOpen, handleClose }: PropsType) => {
  return (
    <CollapseBox component='nav' in={isOpen}>
      {links.map((link) => (
        <HeaderLink
          onClick={handleClose}
          isMenu
          key={link.title}
          path={link.path}
          title={link.title}
        />
      ))}
      <ContactProctorFreeButton isMenu />
      <LogoutButton isMenu />
    </CollapseBox>
  );
};
